/* SpawnAnything — cheap per-instance frustum culling on the CPU (sphere vs 6 planes), used while filling instance
   buffers so off-screen units / buildings cost neither vertex work nor upload bandwidth.
   The planes come from the camera's last matrices: callers that fill buffers before the camera update add a margin. */
import * as THREE from 'three';

export function makeCuller() {
  const fr = new THREE.Frustum(), pm = new THREE.Matrix4(), P = new Float32Array(24);
  return {
    /** refresh from a camera; margin (m) grows every plane outward (covers one frame of camera motion) */
    update(camera, margin = 0) {
      camera.updateMatrixWorld();
      pm.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
      fr.setFromProjectionMatrix(pm);
      for (let i = 0; i < 6; i++) { const p = fr.planes[i]; P[i * 4] = p.normal.x; P[i * 4 + 1] = p.normal.y; P[i * 4 + 2] = p.normal.z; P[i * 4 + 3] = p.constant + margin; }
    },
    /** true if the sphere (x, y, z, r) touches the (grown) frustum */
    sphere(x, y, z, r) {
      for (let i = 0; i < 24; i += 4) if (P[i] * x + P[i + 1] * y + P[i + 2] * z + P[i + 3] < -r) return false;
      return true;
    },
  };
}
